<div class="card_default">
  <div class="card_body">
    <div class="card_header">
      <h4 class="card_title">
        {{"monitoringTasks.productsList"|translate}} <span>({{recordsData.totalProductsCount}})</span>
      </h4>
    </div>
    <div class="card_content">
      <div class="card_inner">
        <div class="table-responsive">
          <table class="table custom-table products-list">
            <thead>
              <tr>
                <th>{{"monitoringTasks.productName"|translate}}</th>
                <th>{{"monitoringTasks.priceRange"|translate}}</th>
                <th>{{"monitoringTasks.monitoredPrice"|translate}}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (record of recordsData.products; track record.monitorTaskProductId) {
              <tr
                [ngClass]="record.monitorStatus == monitorPriceStatusEnum.Price_Above_Range ? 'price-above-range' : record.monitorStatus == monitorPriceStatusEnum.Price_Not_Available ? 'price-not-available' : ''">
                <td>
                  <div class="name-with-image-rounded">
                    <div class="image-rounded">
                      <div class="image">
                        <img *ngIf="record.productImageUrl" [src]="record.productImageUrl"
                          (error)='record.productImageUrl  = "assets/images/no_logo.png"'>
                        <span *ngIf="!record.productImageUrl">
                          {{ record.productName| shortName }}
                        </span>
                      </div>
                    </div>
                    <div class="name">
                      <h5 class="sm-width" [matTooltip]="record.productName">{{record.productName}}</h5>
                    </div>
                  </div>
                </td>
                <td class="nowrap">
                  {{record.lowPrice | number}} <span class="currency-symbol">
                    <img src="./assets/images/icons/Saudi_Riyal_Symbol.svg" alt="">
                  </span> -
                  {{record.highPrice | number}} <span class="currency-symbol">
                    <img src="./assets/images/icons/Saudi_Riyal_Symbol.svg" alt="">
                  </span>
                </td>
                <td *ngIf="record.monitorStatus != monitorPriceStatusEnum.Price_Not_Available">
                  <span class="monitored-price">
                    @if (record.monitorPrice) {
                    {{record.monitorPrice}}
                    }
                    @else {
                    --/--
                    }
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19.884" viewBox="0 0 18 19.884">
                      <path id="Saudi_Riyal_Symbol"
                        d="M16531.2,11557.614l6.8-1.429a7.321,7.321,0,0,1-.615,2.27l-6.8,1.429A7.3,7.3,0,0,1,16531.2,11557.614Zm-10.582-1.5,5.736-1.206v-2.692l-5.357,1.125a7.318,7.318,0,0,1,.615-2.271l4.742-1v-8.319a7.452,7.452,0,0,1,2.117-1.756v9.633l2.117-.446v-6.383a7.532,7.532,0,0,1,2.115-1.758v7.7l5.3-1.112a7.321,7.321,0,0,1-.615,2.27l-4.684.982v2.141l5.3-1.114a7.312,7.312,0,0,1-.615,2.271h0l-6.8,1.428v-4.28l-2.117.444v2.375a1.028,1.028,0,0,1-.18.584v0l-1.1,1.613a1.906,1.906,0,0,1-1.182.778l-6,1.263A7.1,7.1,0,0,1,16520.615,11556.115Z"
                        transform="translate(-16520 -11540)" fill="#91aec0" />
                    </svg>
                  </span>
                </td>
                <td *ngIf="record.monitorStatus == monitorPriceStatusEnum.Price_Not_Available">
                  <div class="monitor-status">
                    <span class="d-flex align-items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12.833" viewBox="0 0 14 12.833">
                        <g id="caution-icon" transform="translate(0 1.999)">
                          <path id="Path_25179" data-name="Path 25179"
                            d="M25.038,23.323l-5.806,10.37a1.265,1.265,0,0,0,0,1.232,1.188,1.188,0,0,0,1.035.616H31.878a1.188,1.188,0,0,0,1.035-.616,1.265,1.265,0,0,0,0-1.232l-5.805-10.37a1.176,1.176,0,0,0-2.069,0Z"
                            transform="translate(-19.072 -24.706)" fill="#d79800" />
                          <path id="Path_108240" data-name="Path 108240"
                            d="M14149.02-9198.414a.643.643,0,0,1,.643-.643.643.643,0,0,1,.646.643.644.644,0,0,1-.646.646A.643.643,0,0,1,14149.02-9198.414Zm-.021-2.3v-2.643a.646.646,0,0,1,.646-.643.642.642,0,0,1,.643.643v2.643a.646.646,0,0,1-.643.646A.65.65,0,0,1,14149-9200.715Z"
                            transform="translate(-14142.653 9205.799)" fill="#fff" />
                        </g>
                      </svg>
                      {{"monitoringTasks.notAvailableInStore" | translate}}
                    </span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center"
                    [ngClass]="record.monitorStatus && record.canMonitoringPrice ? 'justify-content-between' : 'justify-content-end'">
                    <div class="monitor-status" *ngIf="record.monitorStatus">
                      @if (record.monitorStatus == monitorPriceStatusEnum.Price_Above_Range) {
                      <svg id="caution-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="12.833"
                        viewBox="0 0 14 12.833">
                        <path id="Path_25179" data-name="Path 25179"
                          d="M25.038,23.323l-5.806,10.37a1.265,1.265,0,0,0,0,1.232,1.188,1.188,0,0,0,1.035.616H31.878a1.188,1.188,0,0,0,1.035-.616,1.265,1.265,0,0,0,0-1.232l-5.805-10.37a1.176,1.176,0,0,0-2.069,0Z"
                          transform="translate(-19.072 -22.708)" fill="red" />
                        <path id="Path_108240" data-name="Path 108240"
                          d="M14149.02-9198.414a.643.643,0,0,1,.643-.643.643.643,0,0,1,.646.643.644.644,0,0,1-.646.646A.643.643,0,0,1,14149.02-9198.414Zm-.021-2.3v-2.643a.646.646,0,0,1,.646-.643.642.642,0,0,1,.643.643v2.643a.646.646,0,0,1-.643.646A.65.65,0,0,1,14149-9200.715Z"
                          transform="translate(-14142.653 9207.798)" fill="#fff" />
                      </svg>
                      <span>
                        {{"monitoringTasks.outOfRange" | translate}}
                      </span>
                      }
                    </div>
                    <div class="btn-actions">
                      <button mat-raised-button color="primary" *ngIf="record.canMonitoringPrice"
                        (click)="openForm(record.monitorTaskProductId)">
                        {{"monitoringTasks.monitorPrice"|translate}}
                      </button>
                      <button mat-icon-button (click)="filePreview(record.monitorTaskProductId)"
                        *ngIf="record.hasAttachments">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                          <path id="vector"
                            d="M9,5.25V.345a5.233,5.233,0,0,1,1.849,1.193l2.613,2.615A5.215,5.215,0,0,1,14.655,6H9.75A.751.751,0,0,1,9,5.25Zm-2.562,9H3.75a.75.75,0,1,1,0-1.5h2.3a5.664,5.664,0,0,1-.005-1.5H3.75a.75.75,0,0,1,0-1.5H6.445a5.966,5.966,0,0,1,.889-1.5H3.75a.75.75,0,1,1,0-1.5H8.081A2.232,2.232,0,0,1,7.5,5.25V.018C7.379.01,7.259,0,7.136,0H3.75A3.754,3.754,0,0,0,0,3.75v10.5A3.754,3.754,0,0,0,3.75,18h7.5c.086,0,.166-.02.25-.026A6,6,0,0,1,6.438,14.25Zm9.245.373a4.513,4.513,0,1,0-1.061,1.061l2.1,2.1a.751.751,0,0,0,1.061,0h0a.751.751,0,0,0,0-1.061l-2.1-2.1Zm-3.1-.775,0,0a1.533,1.533,0,0,1-2.117-.014L9.326,12.656a.75.75,0,0,1,0-1.04h0a.749.749,0,0,1,1.08,0l1.121,1.165L13.7,10.553a.749.749,0,0,1,1.073,0h0a.749.749,0,0,1,0,1.048l-2.194,2.248Z"
                            fill="#6b6d85" />
                        </svg>
                      </button>
                      <a href="{{ record.aiMatchedProductUrl }}" target="_blank" mat-icon-button
                        *ngIf="record.aiMatchedProductUrl" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.999" viewBox="0 0 18 17.999">
                          <path id="ic_website"
                            d="M17.559,12.066l-6.5-2.958c-.022-.01-.045-.019-.067-.027a1.492,1.492,0,0,0-1.546.359,1.511,1.511,0,0,0-.331,1.613l2.958,6.506a.749.749,0,0,0,.669.439h.014a.752.752,0,0,0,.671-.415l1.388-2.776,2.776-1.388a.75.75,0,0,0-.025-1.354Zm-7.876,4.4c-.129.011-.259.019-.39.025a14.638,14.638,0,0,1-2.718-3.744h.549a.75.75,0,1,0,0-1.5H5.977A7.7,7.7,0,0,1,5.624,9a7.676,7.676,0,0,1,.354-2.25h6.042a8.527,8.527,0,0,1,.221.89.75.75,0,0,0,1.473-.28c-.039-.206-.085-.409-.137-.61h2.575A7.469,7.469,0,0,1,16.5,9q0,.345-.031.682a.75.75,0,0,0,1.494.135C17.984,9.548,18,9.275,18,9a9,9,0,1,0-9,9H9c.275,0,.547-.013.816-.037a.75.75,0,1,0-.132-1.494ZM4.419,11.249H1.845a7.514,7.514,0,0,1,0-4.5H4.419a8.756,8.756,0,0,0,0,4.5Zm2.161-6A14.628,14.628,0,0,1,9,1.809,14.524,14.524,0,0,1,11.423,5.25H6.579Zm8.913,0H13.071a14.748,14.748,0,0,0-2.124-3.492A7.535,7.535,0,0,1,15.492,5.25ZM7.049,1.758A14.733,14.733,0,0,0,4.926,5.25H2.506A7.526,7.526,0,0,1,7.049,1.758ZM2.506,12.749H4.926a14.718,14.718,0,0,0,2.124,3.492A7.535,7.535,0,0,1,2.506,12.749Z"
                            fill="#999aab" />
                        </svg>
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
              }
            </tbody>

          </table>
        </div>

        <div class="pagination-container" *ngIf="recordsData.totalProductsCount > 1">
          <mat-paginator [length]="recordsData.totalProductsCount" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]"
            (page)="getAll($event)" [pageIndex]="pageIndex"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="image-pop" *ngIf="imagePreview">
  <button class="close" (click)="closePreview()">&#x2715;</button>
  <div class="overlay" (click)="closePreview()"></div>
  <img [src]="imagePreview" alt="">
</div>
